module.exports = __webpack_public_path__ + "dc10e8c65e95e289357da37a380187c7.MP3";